module.exports = __webpack_public_path__ + "static/media/latent-venom-arrow.e33370f7.png";